import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import 'react-datepicker/dist/react-datepicker.css'
import { SERVER_URI, URL_EXTENSION } from '../utility/config'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import fi from 'date-fns/locale/fi'

function CreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    window.location.href = `${URL_EXTENSION}calendars`
  }, 1100)
  return (
    <div>
      <h2 className='message_title'>Työvuorot kopioitu ja lisätty</h2>
    </div>
  )
}

function CopyShiftPopUp(props) {
  const [show, setShow] = useState(false)
  const [selectedShiftsList, setSelectedshiftsList] = useState([])
  const [message, setMessage] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [startCopyDate, setStartCopyDate] = useState(null)
  const [endCopyDate, setEndCopyDate] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dates, setDates] = useState([])
  const [weekInterval, setWeekInterval] = useState(6)

  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')
  var days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  const addDays = (originalDate, days) => {
    let cloneDate = new Date(originalDate.valueOf())
    cloneDate.setDate(cloneDate.getDate() + days)
    let endOfDay = moment(cloneDate).endOf('day').toDate()
    return endOfDay
  }

  console.log('data', selectedShiftsList)
  const onChangeWeekInterval = (e) => {
    let weekInterval = e.target.value
    console.log('viikonmäärä', weekInterval)
    if (weekInterval === '1_week') {
      setWeekInterval(6)
    } else if (weekInterval === '2_week') {
      setWeekInterval(13)
    } else if (weekInterval === '3_week') {
      setWeekInterval(20)
    } else if (weekInterval === '4_week') {
      setWeekInterval(27)
    }
  }

  const onChange = (dates) => {
    const [start] = dates
    let End = addDays(start, 6)
    setStartDate(start)
    setEndDate(End)
  }

  const onChangeCopydates = (dates) => {
    const [start] = dates
    let EndCopy = addDays(start, weekInterval)
    setStartCopyDate(start)
    setEndCopyDate(EndCopy)
  }

  // get data from days you want to copy
  const getDataBetweenDates = async (startDate, endDate) => {
    setSelectedshiftsList([])
    let shiftsCopy = []

    shiftsCopy = props.workList.filter(function (a) {
      let date = a.shiftStarts
      return date >= startDate && date <= endDate
    })
    for (let p = 0; p < shiftsCopy.length; p++) {
      var dayStarts = shiftsCopy[p].shiftStarts
      var dayNameStart = days[dayStarts.getDay()]
      var dayEnds = shiftsCopy[p].shiftEnds
      var dayNameEnd = days[dayEnds.getDay()]

      shiftsCopy[p].startWeekday = dayNameStart
      shiftsCopy[p].endWeekday = dayNameEnd
    }
    console.log(shiftsCopy)
    if (shiftsCopy.length === 0) {
      setMessage('no_shifts_found')
    } else {
      setMessage('shifts_fetched')
      setSelectedshiftsList(shiftsCopy)
      window.setTimeout(function () {
        setMessage(false)
      }, 1600)
    }
  }

  // select days where you want to put the copy
  const getDatesBetweenDates = (startCopyDate, endCopyDate) => {
    let dates = []
    setDates([])
    if (endCopyDate === null && startCopyDate === null) {
      setMessage('date_error')
    } else if (endCopyDate === null) {
      setMessage('date_error')
    } else {
      setMessage('dates_added')
      //to avoid modifying the original date
      const theDate = new Date(startCopyDate)
      while (theDate < endCopyDate) {
        dates = [...dates, { shiftDate: new Date(theDate) }]
        theDate.setDate(theDate.getDate() + 1)
      }

      for (let p = 0; p < dates.length; p++) {
        var shiftDate = dates[p].shiftDate
        //get weekdays names
        var dayName = days[shiftDate.getDay()]
        let momentDayStart = moment(new Date(shiftDate)).format('YYYY-MM-DD')
        dates[p].weekday = dayName
        dates[p].shiftDate = momentDayStart
      }
      setDates(dates)
      window.setTimeout(function () {
        setMessage(false)
      }, 1600)
    }
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    let dategroups = {}
    var Difference_In_Time = endCopyDate.getTime() - 1 - startCopyDate.getTime()
    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
    console.log('Testi', Math.floor(Difference_In_Days))

    if (dates.length === 0 || selectedShiftsList.length === 0) {
      alert('Tarkista tiedot!')
    } else if (weekInterval !== Math.floor(Difference_In_Days)) {
      alert('Tarkista kopioitavien päivien määrä')
    } else {
      for (let i = 0; i < selectedShiftsList.length; i++) {
        let newStart = moment(selectedShiftsList[i].shiftStarts, 'YYYY-MM-DDLT')
        let newShiftStart = newStart.format('YYYY-MM-DD')

        if (!dategroups[newShiftStart]) {
          dategroups[newShiftStart] = []
        }

        let infoDate = selectedShiftsList.filter(
          (driver) =>
            moment(driver.shiftStarts).format('YYYY-MM-DD') === newShiftStart
        )

        dategroups[newShiftStart].push(infoDate)
      }
      let selectedShiftsdateArray = []
      for (let newShiftStart in dategroups) {
        selectedShiftsdateArray.push({ date: dategroups[newShiftStart][0] })
      }
      console.log(selectedShiftsdateArray)

      // gets weekdays and filters the ones missing
      let weekdays = []
      for (let a = 0; a < selectedShiftsdateArray.length; a++) {
        for (let w = 0; w < selectedShiftsdateArray[a].date.length; w++) {
          let weekday = selectedShiftsdateArray[a].date[w].startWeekday
          weekdays.push(weekday)
        }
      }

      var filteredDates = dates.filter(function (cItem) {
        return weekdays.find(function (aItem) {
          return cItem.weekday === aItem
        })
      })
      let multiply = filteredDates.length / selectedShiftsdateArray.length
      let realMultiply = multiply - 1
      // copy array and push array into the copy as many times as multiplier says
      let selectedShiftsdateArrayCopy = [...selectedShiftsdateArray]
      for (var i = 0; i < realMultiply; i++) {
        selectedShiftsdateArrayCopy.push.apply(
          selectedShiftsdateArrayCopy,
          selectedShiftsdateArray
        )
      }

      // get dates from the two lists with same index and also get the info
      for (let n = 0; n < filteredDates.length; n++) {
        for (let w = 0; w < selectedShiftsdateArrayCopy[n].date.length; w++) {
          let shiftEndsTime = selectedShiftsdateArrayCopy[n].date[w].shiftEnds
          let shiftStartsTime =
            selectedShiftsdateArrayCopy[n].date[w].shiftStarts
          let driverID = selectedShiftsdateArrayCopy[n].date[w].driverId
          let vehicleID = selectedShiftsdateArrayCopy[n].date[w].vehicleId
          let newShiftDate = filteredDates[n].shiftDate

          // conversion into hours and minutes
          let shiftStartTime = moment(shiftStartsTime, 'HH:mm')
          let shiftEndTime = moment(shiftEndsTime, 'HH:mm')
          var ShiftTimeStart = shiftStartTime.format('HH:mm')
          var ShiftTimeEnd = shiftEndTime.format('HH:mm')

          //check over Midnight going shifts
          //convert dates to compare them
          let startDate = moment(shiftStartsTime, 'YYYY-MM-DD')
          let endDate = moment(shiftEndsTime, 'YYYY-MM-DD')
          let shiftStartDate = startDate.format('YYYY-MM-DD')
          let shiftEndtDate = endDate.format('YYYY-MM-DD')

          if (shiftStartDate !== shiftEndtDate) {
            //create new endDate
            var newShiftEndDate = new Date(filteredDates[n].shiftDate)
            newShiftEndDate.setDate(new Date(newShiftDate).getDate() + 1)
            var endMomentDate = moment(
              newShiftEndDate,
              'ddd MMM D YYYY HH:mm ZZ'
            )

            let shiftEndsHours = new Date(shiftEndsTime).getHours()
            let shiftEndsMinutes = new Date(shiftEndsTime).getMinutes()
            endMomentDate.set({ h: shiftEndsHours, m: shiftEndsMinutes })

            //conversions to full dates
            let newStart = moment(newShiftDate + ShiftTimeStart, 'YYYY-MM-DDLT')
            let newShiftStart = newStart.format('YYYY-MM-DDTHH:mm')
            var newShiftEnds = endMomentDate.format('YYYY-MM-DDTHH:mm')

            let shiftData = {
              driverId: driverID,
              vehicleId: vehicleID,
              shiftStarts: new Date(Date.parse(newShiftStart)).toString(),
              shiftEnds: new Date(Date.parse(newShiftEnds)).toString(),
            }
            try {
              await axios.post(
                `${SERVER_URI}/add_reserved_work_shift`,
                shiftData,
                { headers: { Authorization: `Token ${userToken}` } }
              )
            } catch (e) {
              console.log('Error in adding shift', e)
            }
            setLoading(true)
          } else {
            // conversion to full dates, new date comppined with the hours and minutes of the old one
            let newStart = moment(newShiftDate + ShiftTimeStart, 'YYYY-MM-DDLT')
            let newShiftStart = newStart.format('YYYY-MM-DDTHH:mm')
            let newEnd = moment(newShiftDate + ShiftTimeEnd, 'YYYY-MM-DDLT')
            let newShiftEnds = newEnd.format('YYYY-MM-DDTHH:mm')

            // create one work shift
            let shiftData = {
              driverId: driverID,
              vehicleId: vehicleID,
              shiftStarts: new Date(Date.parse(newShiftStart)).toString(),
              shiftEnds: new Date(Date.parse(newShiftEnds)).toString(),
            }

            try {
              await axios.post(
                `${SERVER_URI}/add_reserved_work_shift`,
                shiftData,
                { headers: { Authorization: `Token ${userToken}` } }
              )
            } catch (e) {
              console.log('Error in adding shift', e)
            }
            setLoading(true)
          }
        }
      }
      window.setTimeout(function () {
        // refresh the page after loading
        setLoading(false)
        setShow(!show)
      }, 1400)
    }
  }

  return (
    <div>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <div className={loading === true ? 'loading' : 'notloading'}>
                Lisätään työvuoroja
              </div>
              <h2 className='popUp_title'>Kopioi Työvuoroja</h2>
              <label className='label_add' htmlFor='getDates'>
                Valitse aikaväli:
              </label>
              <DatePicker
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                locale={fi}
                selectsRange
                inline
              />
              <DatePicker
                selected={startDate}
                dateFormat='dd.MM.yyyy'
                disabled
                placeholderText='Aloituspäivä'
              />
              -
              <DatePicker
                selected={endDate}
                dateFormat='dd.MM.yyyy'
                placeholderText='Lopetuspäivä'
                disabled
              />
              <br />
              <button
                id='lightBlue_button'
                onClick={() => getDataBetweenDates(startDate, endDate)}
              >
                Hae vuorot
              </button>
              <br />
              {message === 'no_shifts_found' ? (
                <div>
                  <label htmlFor='message' className='errorMessage'>
                    Ei vuoroja
                  </label>
                </div>
              ) : (
                ''
              )}
              {message === 'shifts_fetched' ? (
                <div>
                  <label htmlFor='message' className='successMessage'>
                    Vuorot haettu
                  </label>
                </div>
              ) : (
                ''
              )}
              <label className='label_add' htmlFor='getDates'>
                Valitse aikaväli jolle haluat kopioida vuorot:
              </label>
              <br />
              <select
                name='ChooseWeekInterval'
                id='ChooseWeekInterval'
                defaultValue='1_week'
                onChange={(e) => onChangeWeekInterval(e)}
              >
                <option value='1_week'>1 viikko</option>
                <option value='2_week'>2 viikkoa</option>
                <option value='3_week'>3 viikkoa</option>
                <option value='4_week'>4 viikkoa</option>
              </select>
              <DatePicker
                onChange={onChangeCopydates}
                startDate={startCopyDate}
                endDate={endCopyDate}
                locale={fi}
                selectsRange
                inline
              />
              <DatePicker
                selected={startCopyDate}
                dateFormat='dd.MM.yyyy'
                disabled
                placeholderText='Aloituspäivä'
              />
              -
              <DatePicker
                selected={endCopyDate}
                dateFormat='dd.MM.yyyy'
                placeholderText='Lopetuspäivä'
                disabled
              />
              <br />
              <button
                id='lightBlue_button'
                onClick={() => getDatesBetweenDates(startCopyDate, endCopyDate)}
              >
                Tallenna päivämäärät
              </button>
              {message === 'date_error' ? (
                <div>
                  <label htmlFor='message' className='errorMessage'>
                    Tarkista päivämäärät!
                  </label>
                </div>
              ) : (
                ''
              )}
              {message === 'dates_added' ? (
                <div>
                  <label htmlFor='message' className='successMessage'>
                    Päivät tallennettu
                  </label>
                </div>
              ) : (
                ''
              )}
              <form className='shiftCopy_form'>
                <input
                  type='submit'
                  id='gradient_Button'
                  onClick={(e) => doSubmit(e)}
                  value='Lisää kopioidut työvuorot'
                />
              </form>
            </div>
          )}
          {show && <CreatedMessage />}
        </div>
      </div>
    </div>
  )
}

export default CopyShiftPopUp
